var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lease-wrapper"},[_c('div',{staticClass:"lease"},_vm._l((_vm.leaseParagraphs),function(paragraph,index){return _c('p',{key:`${index}-${paragraph.text}`,class:{ 'lease__emphasis': paragraph.isEmphasis }},[(paragraph.label)?_c('strong',[_vm._v(_vm._s(paragraph.label))]):_vm._e(),_vm._v(_vm._s(paragraph.body)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }